import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconUserBlock: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"user-block, people, person, member, blocked"} maskId="square-outlined-radius-0-stroke-1-IconUserBlock"><path d="M12 20.5H4.5V19.5C4.5 15.3579 7.85786 12 12 12" stroke="currentColor"/><circle cx="12" cy="7.5" r="4.5" stroke="currentColor"/><circle cx="18" cy="17.25" r="3.5" stroke="currentColor"/><path d="M15.7461 19.5L20.2461 15" stroke="currentColor"/></CentralIconBase>;
}));

export default IconUserBlock;
